const { loadScript, loadStyle } = require('./util/loadDependencies');

export default (jsBasePath) => jQuery(($) => {
    const cityInput = document.querySelector('input#city');
    const zipInput = document.querySelector('input#zipcode');
    if (cityInput.value !== '' || zipInput.value !== '') {
        $('select#within').prop( "disabled", false );
    }
    cityInput.addEventListener('input', (e) => {
        if (cityInput.value !== '' || zipInput.value !== '') {
            $('select#within').prop( "disabled", false );
        } else {
            $('select#within').prop( "disabled", true );
        }
    });
    zipInput.addEventListener('input', (e) => {
        if (zipInput.value !== '' || cityInput.value !== '') {
            $('select#within').prop( "disabled", false );
        } else {
            $('select#within').prop( "disabled", true );
        }
    });


    const triggerLightbox = () => {
        $('.alumni-directory__person-expand > a').on('click', function (e) {
            $(this).modaal({
                type: 'inline',
                start_open: true
            });
        });
    };

    const form = $('.campus-directory__search-panel form');

    const directory = $('.alumni-directory');

    form.submit(function (e) {
        directory.addClass('campus-directory--pending-results');
        $('.campus-directory__waiting-indicator').show();
    });

    $('.campus-directory__clear-form').click(function (event) {
        event.preventDefault();
        form.find('input[type="text"]').each(function () {
            $(this).val(''); // clears text inputs
        });

        form.find('select').each(function () {
            $(this)[0].selectedIndex = 0;
        }); // defaults selects to first item

        directory.addClass('campus-directory--pending-results');
        $('.campus-directory__waiting-indicator').hide();
        $('#scopeAffiliation').change();
        $('#firstName').focus();

        console.log('Directory Search form cleared');
    });

    $('.campus-directory__start-link').click(function (event) {
        event.preventDefault();
        $('#fullName').focus();
    });

    $('.alumni-directory form').submit( function ( event ) {
        event.preventDefault();

        let getVars = [];
        $.each( $(this).find('input'), function (index, item) {
            if ($(item).attr('type') != 'submit' && $(item).val()) {
                if ($(item).attr('name') == 'datalist-input') {
                    // skip it
                } else {
                    getVars.push( $(item).attr('name') + '=' + $(item).val() );
                }
            }
        } );
        $.each( $(this).find('select'), function (index, item) {
            if ($(item).val()) {
                if ( $(item).attr('name') == 'scopeAffiliation' && $(item).val() == 'all' ) {
                    // skip it
                } else if ($(item).attr('name') == 'within' && !$('#city').val() && !$('#zipcode').val()) {
                    // skip it
                } else {
                    getVars.push( $(item).attr('name') + '=' + encodeURIComponent( $(item).val() ) );
                }
            }
        } );

        window.location.href = '?' + getVars.join('&');
    });

    loadStyle(`${jsBasePath}../vendor/modaal/css/modaal.min.css`);
    loadScript(`${jsBasePath}../vendor/modaal/js/modaal.min.js`, triggerLightbox);
});
